import { Spinner } from '@/components/ui/spinner';
import { useAuth } from "./ParsleeAuthProvider";
import { UnauthenticatedGate } from "./UnauthenticatedGate";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that requires authentication.
 *
 * On unauth, renders the shared UnauthenticatedGate (the sign-in card +
 * cooldown-gated silent platform probe) rather than redirecting to a
 * probe-less page. This keeps the signed-out experience identical across every
 * route.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spinner size={32} label="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <UnauthenticatedGate />;
  }

  return <>{children}</>;
}
